export default "__VITE_ASSET__FapCvAKR__"